export default {
    HOME_SERVICE: 'HOME_SERVICE',
    PICK_UP: 'PICK_UP',
}